export default __webpack_public_path__ + "static/media/CNo.83-3.6bc505ab.jpg";